import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { btnPrimary } from "@/components/admin/ui";
import { ContractForm } from "@/components/admin/ContractForm";
import { ContractCard } from "@/components/admin/ContractCard";
import { IssuerSettings } from "@/components/admin/IssuerSettings";

export function InvitationsAdmin({ onSelectCode }) {
  const [list, setList] = useState([]);
  const [mode, setMode] = useState(null);
  const load = () => api.get("/admin/invitations").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);

  const toggle = async (inv) => { await api.put(`/admin/invitations/${inv.code}`, { active: !inv.active }); load(); };
  const remove = async (inv) => {
    if (!window.confirm(`Hapus kode ${inv.code}?\n\nPERHATIAN: semua siswa yang terdaftar dengan kode ini akan langsung TIDAK BISA login/akses sampai kode dibuat lagi. Untuk memblokir sementara, gunakan 'Nonaktifkan'.`)) return;
    try { await api.delete(`/admin/invitations/${inv.code}`); toast.success("Kode dihapus"); load(); } catch (ex) { toast.error(errMsg(ex)); }
  };
  const summary = { total: list.length, active: list.filter((i) => i.contract_status === "active").length, expiring: list.filter((i) => i.contract_status === "expiring").length, expired: list.filter((i) => i.contract_status === "expired").length };

  return (
    <div className="space-y-6" data-testid="admin-invitations">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex flex-wrap gap-2 text-xs" data-testid="contract-summary-chips">
          {[["Lembaga", summary.total], ["Kontrak aktif", summary.active], ["Segera berakhir", summary.expiring], ["Kadaluarsa", summary.expired]].map(([l, v]) => <span key={l} className="rounded-full bg-muted px-3 py-1"><span className="font-semibold">{v}</span> {l}</span>)}
        </div>
        {!mode && <button data-testid="contract-new-button" onClick={() => setMode("new")} className={btnPrimary}><Plus className="h-4 w-4" />Lembaga & kontrak baru</button>}
      </div>
      {mode === "new" && <ContractForm onSaved={() => { setMode(null); load(); }} onCancel={() => setMode(null)} />}
      {mode && mode !== "new" && <ContractForm key={mode.code} initial={mode} onSaved={() => { setMode(null); load(); }} onCancel={() => setMode(null)} />}
      <IssuerSettings />
      <div className="space-y-3">
        {list.map((inv) => <ContractCard key={inv.code} inv={inv} onEdit={setMode} onToggle={toggle} onDelete={remove} onStudents={(c) => onSelectCode?.(c)} />)}
      </div>
    </div>
  );
}
